export interface ItemProcessamento {
  situacao: SituacaoProcessamento;
  dataPendente: Date;
  dataProcessamento: Date;
  erro: string;
  numeroFalhas: number;
}

export enum SituacaoProcessamento {
  PENDENTE = 'PENDENTE',
  PROCESSADO = 'PROCESSADO',
  INAPTO = 'INAPTO',
  SUSPENSO = 'SUSPENSO',
  QUARENTENA = 'QUARENTENA',
  EXCLUIDO = 'EXCLUIDO',
  FALHA_PROCESSAMENTO = 'FALHA_PROCESSAMENTO'
}
